var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 63,
    viewBox: "0 0 81 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 13.5,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 23.5,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 33.5,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 43.5,
    width: 14.25,
    height: 6,
    rx: 1,
    fill: "#80959B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8081,
    y: 45.5,
    width: 7.63393,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 43.5,
    width: 14.25,
    height: 6,
    rx: 1,
    fill: "#80959B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0581,
    y: 45.5,
    width: 7.63393,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 43.5,
    width: 14.25,
    height: 6,
    rx: 1,
    fill: "#80959B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44.3081,
    y: 45.5,
    width: 7.63393,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56.25,
    y: 43.5,
    width: 14.25,
    height: 6,
    rx: 1,
    fill: "#80959B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5581,
    y: 45.5,
    width: 7.63393,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomNavigation);
export default __webpack_public_path__ + "static/media/BottomNavigation.9630ae3445bcc208919f30161eba471a.svg";
export { ForwardRef as ReactComponent };